import { createFileRoute } from '@tanstack/react-router';
import { GiveawayLiveDrawPage } from '@/features/marketing';

/** The filmed Live draw screen of one prize: full screen, no app chrome. */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway_/live')({
  validateSearch: (search: Record<string, unknown>): { prize?: string } =>
    typeof search.prize === 'string' && search.prize !== '' ? { prize: search.prize } : {},
  component: GiveawayLiveDrawRoute,
});

function GiveawayLiveDrawRoute() {
  const { orgId, campaignId } = Route.useParams();
  const { prize } = Route.useSearch();
  return <GiveawayLiveDrawPage orgId={orgId} campaignId={campaignId} prizeId={prize ?? null} />;
}
